import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { showMessage } from "../../actions/FlashMessageActions";
import {
  getDetails,
  setDetails,
  setProfilePic,
  getInterests,
} from "../../actions/AccountActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { console_log } from "../../utils/helper";
import Feedback from "./../feedback/feedback";
import { config } from "../../constants/domainConfig";
import { FormattedMessage } from "react-intl";
import VideoPlayerModal from "./VideoPlayerModal";
import { sendData } from "../../analytics/sendData";
import { onUnsubClick, unsubscribeTextFun } from "../../utils/unsubHelper";
import { Link } from "react-router-dom";
import {
  isMobio360Plus,
  isMundo360,
  getText,
} from "../../constants/multiDomains";
import { isWithdrawEnabled } from "../../utils/withdrawContract";

const zaDomain = config.domain == "za" ? true : false;
const bizaoDomain =
  config.domain == "ci" ||
  config.domain == "eg" ||
  config.domain == "cd" ||
  config.domain == "cm" ||
  config.domain == "tn" ||
  config.domain == "sn" ||
  config.domain == "pt"
    ? true
    : false;
const belgiumDomain = config.domain == "be" ? true : false;
const turkeyDomain = config.domain == "tr" ? true : false;
const ptDomain = config.domain == "pt" ? true : false;
const kwDomain = config.domain == "kw" ? true : false;
const bhDomain = config.domain == "bh" ? true : false;

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      emailAddress: "",
      location: "",
      interests: [],
      accountType: "standard",
      timeZone: "+0:00",
      photo: "",
      photoFile: null,
      isPlaying: false,
      feedbackModal: false,
      username: sessionStorage.getItem("username"),
      pwd: sessionStorage.getItem("password"),
      showNewPwdField: false,
      newPwd: "",
      showUnsubscribeConfirm: false,
    };
    this.editForm = this.editForm.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.feedbackModalToggle = this.feedbackModalToggle.bind(this);
    this.translateInterests = this.translateInterests.bind(this);
    this.toggleVideoPlayer = this.toggleVideoPlayer.bind(this);
    this.handleVerifyEmail = this.handleVerifyEmail.bind(this);
    this.toggleNewPwdField = this.toggleNewPwdField.bind(this);
    this.changePwd = this.changePwd.bind(this);
    this.onUnsubClickKW = this.onUnsubClickKW.bind(this);
    this.onUnsubClickBH = this.onUnsubClickBH.bind(this);
    this.openUnsubscribeConfirm = this.openUnsubscribeConfirm.bind(this);
    this.closeUnsubscribeConfirm = this.closeUnsubscribeConfirm.bind(this);
    this.confirmUnsubscribe = this.confirmUnsubscribe.bind(this);
  }

  componentWillMount() {
    axios
      .get(vars.BASE_API_URL + "/getUserProfile")
      .then((userProfile) => {
        if (userProfile.data.data) {
          this.props.getDetails(userProfile.data.data);
        }
      })
      .catch((err) => {});
    this.setState({
      name: this.props.account.user.name,
      emailAddress: this.props.account.user.email,
      location: this.props.account.user.address,
      interests: this.props.account.user.userInterests
        ? this.props.account.user.userInterests.map((i) => {
            return i.interestId;
          })
        : [],
      accountType: this.props.account.user.accountType,
      timeZone: this.props.account.user.timeZone,
    });
    if (
      config.lang == "be" ||
      config.lang == "ar" ||
      config.lang == "tr" ||
      config.lang == "pt" ||
      config.lang == "no"
    )
      this.props.account.interests = this.translateInterests(
        this.props.account.interests,
      );
  }

  componentDidMount() {
    sendData("", "", "video", "viewed", { page: "my account" });
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1500);
    document.body.classList.add("gradient-bg-dark");
    const myAcc = {
      en: "My Account",
      fr: "Mon compte",
      be: "Mijn account",
      tr: "Hesabım",
      ar: "الحساب",
      cy: "Мој профил",
      ee: "Minu konto",
      es: "Mi cuenta",
      el: "Ο Λογαριασμός Μου",
      id: "Akun saya",
    };
    this.props.setHeaderTitle(myAcc[config.lang]);
    window.scrollTo(0, 0);
  }

  translateInterests(interests) {
    let interestsEn = [
      "Sports",
      "Action",
      "Adventure",
      "Fitness",
      "Entertainment",
    ];
    let interestsBe = [
      "Sporten",
      "Actie",
      "Avontuur",
      "Fitness",
      "Entertainment",
    ];
    let interestsTr = ["Spor", "Aksiyon", "Macera", "Fitness", "Eğlence"];
    let interestsAr = ["رياضات", "اكشن", "مغامرة", "اللياقه البدنيه", "ترفيه"];
    let interestsPt = [
      "Desporto",
      "Ação",
      "Aventura",
      "Fitness",
      "Entretenimento",
    ];
    let interestsNo = [
      "Sport",
      "Action",
      "Eventyr",
      "Fitness",
      "Underholdning",
    ];
    let translatedInterests = interests.map((interest) => {
      if (interestsEn.includes(interest.name)) {
        if (config.lang === "be") {
          return {
            ...interest,
            name: interestsBe[interestsEn.indexOf(interest.name)],
          };
        } else if (config.lang === "tr") {
          return {
            ...interest,
            name: interestsTr[interestsEn.indexOf(interest.name)],
          };
        } else if (config.lang === "pt") {
          return {
            ...interest,
            name: interestsPt[interestsEn.indexOf(interest.name)],
          };
        } else if (config.lang === "no") {
          return {
            ...interest,
            name: interestsNo[interestsEn.indexOf(interest.name)],
          };
        } else if (config.lang === "ar") {
          return {
            ...interest,
            name: interestsAr[interestsEn.indexOf(interest.name)],
          };
        }
      } else {
        return interest;
      }
    });
    return translatedInterests;
  }

  componentWillUnmount() {
    document.body.classList.remove("gradient-bg-dark");
  }

  editForm(e) {
    if (this.validateForm()) {
      this.submitForm();
    }
  }

  validateForm() {
    let regExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (
      this.state.emailAddress != "" &&
      !regExp.test(this.state.emailAddress)
    ) {
      this.props.showMessage({
        message: messages[config.lang].emailNotValid,
        type: false,
      });
      return false;
    }
    return true;
  }

  submitForm() {
    let user = this.props.account.user;
    user.name = this.state.name;
    user.email = this.state.emailAddress;
    user.address = this.state.location;
    user.interests = this.state.interests;
    user.accountType = this.state.accountType;
    user.timeZone = this.state.timeZone;

    axios
      .put(vars.BASE_API_URL + "/editProfile", user)
      .then((response) => {
        this.props.showMessage({
          message: messages[config.lang].profileSaved,
          type: true,
        });
        console_log(response);
      })
      .catch((error) => {
        console_log(error);
      });
    this.props.setDetails(user);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onCategoryChange(e) {
    let interest = this.state.interests,
      indexOf = interest.indexOf(parseInt(e.target.name));
    if (indexOf === -1) {
      interest.push(parseInt(e.target.name));
    } else {
      interest = interest.filter((c) => c !== parseInt(e.target.name));
    }
    this.setState({
      interests: interest,
    });
  }
  handleVerifyEmail() {
    let account = sessionStorage.getItem("mobiotv")
      ? JSON.parse(sessionStorage.getItem("mobiotv")).AccountReducer
      : null;
    axios
      .get(`${vars.BASE_API_URL}/send_verify_email/${account.user.uid}`)
      .then((res) => {
        if (res.data && res.data.success) {
          this.props.showMessage({
            message: messages[config.lang].verificationEmailSentto,
            type: true,
          });
        } else {
          this.props.showMessage({
            message: messages[config.lang].somethingWentWrong,
            type: false,
          });
        }
      });
  }
  onFileChange(e) {
    let reader = new FileReader(),
      file = e.target.files[0];
    let base64Data;
    reader.readAsDataURL(file);
    let currentThis = this;
    reader.onloadend = function () {
      base64Data = reader.result;
      currentThis.props.show();
      axios
        .post(vars.BASE_API_URL + "/upload", { profilePic: base64Data })
        .then((response) => {
          currentThis.props.showMessage({
            message: messages[config.lang].profilePic,
            type: true,
          });
          currentThis.props.setProfilePic(response.data.data.profilePic);
          currentThis.props.hide();
        })
        .catch((error) => {
          currentThis.props.hide();
          console_log(error);
        });
      currentThis.setState({
        photo: [reader.result],
        photoFile: file,
      });
    };
  }
  feedbackModalToggle() {
    this.setState({
      feedbackModal: !this.state.feedbackModal,
    });
  }

  toggleVideoPlayer() {
    this.setState({
      isPlaying: !this.state.isPlaying,
    });
  }

  toggleNewPwdField() {
    this.setState({
      showNewPwdField: !this.state.showNewPwdField,
    });
  }
  transformRequest(headers) {
    delete headers.common.authorization;
    return;
  }
  changePwd() {
    this.transformRequest(axios.defaults.headers);
    if (this.state.newPwd == "") {
      alert("A senha não pode estar vazia");
      return;
    }
    this.props.show();
    axios
      .get(
        `https://de-mcb-api.sam-media.com/api/v2/retrieve-password/pt/go4mobility?msisdn=${this.state.username}&domain=pt.mobio360.com&new_password=${this.state.newPwd}`,
      )
      .then((resp) => {
        this.props.hide();
        console.log(resp.data);
        if (resp.data.state == "success") {
          sessionStorage.setItem("password", this.state.newPwd);
          this.setState({
            pwd: this.state.newPwd,
          });
          alert("Senha alterada com sucesso");
        } else alert("Ocorreu um erro. Por favor tente novamente.");
      })
      .catch((err) => {
        console.log("error---------------", err);
      })
      .finally(() => {
        this.toggleNewPwdField();
      });
  }
  openUnsubscribeConfirm(e) {
    e.preventDefault();
    this.setState({ showUnsubscribeConfirm: true });
  }
  closeUnsubscribeConfirm() {
    this.setState({ showUnsubscribeConfirm: false });
  }
  confirmUnsubscribe() {
    this.closeUnsubscribeConfirm();
    onUnsubClick(null, this.props.showMessage);
  }
  onUnsubClickKW(e) {
    if (e) e.preventDefault();
    this.transformRequest(axios.defaults.headers);
    const uid = JSON.parse(sessionStorage.getItem("authorized"))
      ? JSON.parse(sessionStorage.getItem("authorized")).uid
      : "";
    console.log("enter");
    axios
      .get(
        `https://de-mcb-api.sam-media.com/api/v1/Unsubscribe?token=${uid}&country=kw`,
      )
      .then((resp) => {
        console.log(resp.data);
        if (resp.data.state == "success") {
          window.open(resp.data.payload.gw_unsub_url);
        }
      })
      .catch((err) => {
        console.log("error---------------", err);
      });
  }
  onUnsubClickBH(e) {
    if (e) e.preventDefault();
    this.transformRequest(axios.defaults.headers);
    const uid = JSON.parse(sessionStorage.getItem("authorized"))
      ? JSON.parse(sessionStorage.getItem("authorized")).uid
      : "";
    console.log("enter");
    axios
      .get(
        `https://de-mcb-api.sam-media.com/api/v1/Unsubscribe?token=${uid}&country=bh`,
      )
      .then((resp) => {
        console.log(resp.data);
        if (resp.data.state == "success") {
          window.open(resp.data.payload.gw_unsub_url);
        }
      })
      .catch((err) => {
        console.log("error---------------", err);
      });
  }
  render() {
    const { isPlaying, showUnsubscribeConfirm } = this.state;
    // const { account}=this.props;
    const { domain, lang, country } = config;
    const showMundoUnsubscribeConfirm =
      config.domain === "mx" && isMundo360();
    const productName = window.location.hostname;
    let account = sessionStorage.getItem("mobiotv")
      ? JSON.parse(sessionStorage.getItem("mobiotv")).AccountReducer
      : null;
    const ppLinkBizao = {
      ci: "http://n.mobi360vr.com/ci/tnc-mobio360?offer=1&_next=privacy_policy.html",
      cd: "http://n.mobi360vr.com/cd/tnc-mobio360?offer=1&_next=privacy_policy.html",
      cm: "http://n.mobi360vr.com/cm/tnc-mobio360?offer=1&_next=privacy_policy.html",
      tn: "http://n.mobi360vr.com/tn/tnc-mobio360?offer=1&operator=TN_ORANGE&operatorSubmitted=Y&_next=privacy_policy.html",
      sn: "http://n.mobi360vr.com/sn/tnc-mobio360?offer=1&_next=privacy_policy.html",
    };
    const tncLinkBizao = {
      ci: "http://n.mobi360vr.com/ci/tnc-mobio360?offer=1&_next=general_conditions.html",
      cd: "http://n.mobi360vr.com/cd/tnc-mobio360?offer=1&_next=general_conditions.html",
      cm: "http://n.mobi360vr.com/cm/tnc-mobio360?offer=1&_next=general_conditions.html",
      tn: "http://n.mobi360vr.com/tn/tnc-mobio360?offer=1&operator=TN_ORANGE&operatorSubmitted=Y&_next=general_conditions.html",
      sn: "http://n.mobi360vr.com/sn/tnc-mobio360?offer=1&_next=general_conditions.html",
      pt: "http://n.mobi360vr.com/pt/tnc-mobio360?device=pc&offer=1",
      eg: `http://n.mobi360vr.com/eg/eg-mm-mobio360?offer=1&msisdn=${this.props.access.subscriptionInfo.msisdn_full}`,
    };
    let intrestsEnglish = [
      "Sports",
      "Action",
      "Adventure",
      "Fitness",
      "Entertainment",
    ];
    return (
      <section
        className="account"
        style={config.dir === "rtl" ? { direction: "ltr" } : {}}
      >
        <div className="feedback-class" onClick={this.feedbackModalToggle}>
          <div>
            <span>
              <b>
                <FormattedMessage id="feedback" defaultMessage="FEEDBACK" />
              </b>
            </span>
          </div>
        </div>
        <Feedback
          feedbackModalToggle={this.feedbackModalToggle}
          feedbackModal={this.state.feedbackModal}
        />
        <button
          className="edit-button"
          onClick={this.editForm}
          style={
            config.lang === "ar" ? { left: 20 + "px", right: "unset" } : {}
          }
        >
          <FormattedMessage id="save" defaultMessage="Save" />
        </button>
        <Container fluid>
          <Form className="account-form" action="" method="post">
            <Row>
              <Col sm="8" xs="7">
                <div className="account__fields">
                  <h3 className="account__title">
                    <FormattedMessage
                      id="accountDetails"
                      defaultMessage="Account Details"
                    />
                  </h3>
                  <div className="account__input">
                    <label className="account__input__label" htmlFor="name">
                      <FormattedMessage id="name" defaultMessage="Name" />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="name"
                      id="name"
                      value={this.state.name}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="account__input">
                    <label
                      className="account__input__label"
                      htmlFor="emailAddress"
                    >
                      <FormattedMessage
                        id="emailAdd"
                        defaultMessage="Email Address"
                      />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="emailAddress"
                      id="emailAddress"
                      value={this.state.emailAddress}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                {account.interests ? (
                  <div className="account__fields">
                    <h3 className="account__title">
                      <FormattedMessage
                        id="interests"
                        defaultMessage="Interests"
                      />
                    </h3>
                    <span className="hint-text">
                      <FormattedMessage
                        id="chooseYourCat"
                        defaultMessage="Choose your interest"
                      />
                    </span>
                    <div className="account__checkbox-wrap">
                      {account.interests.map((interest, k) => {
                        return (
                          <div key={k} className="account__input">
                            <input
                              type="checkbox"
                              className="common-checkbox"
                              name={interest.interestId}
                              id={interest.interestId}
                              checked={
                                this.state.interests.indexOf(
                                  interest.interestId,
                                ) !== -1
                                  ? true
                                  : false
                              }
                              onChange={this.onCategoryChange}
                            />
                            <label
                              className="account__default__label"
                              htmlFor={interest.interestId}
                            >
                              <FormattedMessage
                                id={intrestsEnglish[k]}
                                defaultMessage={intrestsEnglish[k]}
                              />
                              {/* {interest.name} */}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                    {zaDomain ||
                    bizaoDomain ||
                    belgiumDomain ||
                    turkeyDomain ||
                    ptDomain ||
                    kwDomain ||
                    bhDomain ||
                    (config.domain == "sa" && !isMobio360Plus()) ||
                    config.domain == "no" ||
                    config.domain == "th" ||
                    config.domain == "mx" ||
                    config.domain == "fr" ? (
                      <div>
                        {zaDomain || config.domain == "no" ? (
                          <div className="create-your-goggle">
                            <div
                              className="account__unsubscribe"
                              onClick={this.toggleVideoPlayer}
                            >
                              <h3>
                                <a href="javascript:void(0)" download>
                                  <FormattedMessage
                                    id="create_your_goggle"
                                    defaultMessage="Create your goggle"
                                  />
                                </a>
                              </h3>
                            </div>

                            <div className="account__unsubscribe">
                              <h3>
                                <a
                                  href="https://cdn.mobio360.com/diy/plan.jpg"
                                  download
                                >
                                  <FormattedMessage
                                    id="download_blueprint"
                                    defaultMessage="Download Blueprint"
                                  />
                                </a>
                              </h3>
                            </div>
                            <VideoPlayerModal
                              isPlaying={isPlaying}
                              toggleVideoPlayer={this.toggleVideoPlayer}
                            />
                          </div>
                        ) : null}
                        {ptDomain && (
                          <div>
                            <div className="account__fields">
                              <h3 className="account__unsubscribe">
                                <FormattedMessage
                                  id="username"
                                  defaultMessage="Username"
                                />
                              </h3>{" "}
                              {sessionStorage.getItem("username")}
                              <h3 className="account__unsubscribe">
                                <FormattedMessage
                                  id="password"
                                  defaultMessage="Password"
                                />
                              </h3>{" "}
                              {sessionStorage.getItem("password")}
                            </div>
                            <div className="navigate-item">
                              <a
                                className="btn btn-danger"
                                style={{
                                  fontFamily: "monospace",
                                  color: "black",
                                }}
                                onClick={this.toggleNewPwdField}
                              >
                                <FormattedMessage
                                  id="changePwd"
                                  defaultMessage="Change Password"
                                />
                              </a>
                            </div>

                            {this.state.showNewPwdField && (
                              <div className="account__input">
                                <label
                                  className="account__input__label"
                                  htmlFor="newPwd"
                                >
                                  <FormattedMessage
                                    id="newPwd"
                                    defaultMessage="New Password"
                                  />
                                </label>
                                <input
                                  className="account__input__field"
                                  type="text"
                                  name="newPwd"
                                  id="newPwd"
                                  maxLength="6"
                                  value={this.state.newPwd}
                                  onChange={this.onChange}
                                />
                                <a className="ok-btn" onClick={this.changePwd}>
                                  OK
                                </a>
                                <a
                                  className="ok-btn"
                                  onClick={this.toggleNewPwdField}
                                >
                                  <FormattedMessage
                                    id="cancel"
                                    defaultMessage="Cancel"
                                  />
                                </a>
                              </div>
                            )}

                            <div className="navigate-item">
                              <Link
                                className="btn btn-danger reg-link"
                                to={`/forgot-password/`}
                                style={{
                                  fontFamily: "monospace",
                                  color: "black",
                                }}
                              >
                                <FormattedMessage
                                  id="forgot-password-link"
                                  defaultMessage="Forgot Password"
                                />
                              </Link>
                            </div>
                          </div>
                        )}

                        {config.domain === "eg" ||
                        zaDomain ||
                        kwDomain ||
                        bhDomain ? null : (
                          <div className="navigate-item">
                            <a
                              href=""
                              onClick={
                                showMundoUnsubscribeConfirm
                                  ? this.openUnsubscribeConfirm
                                  : (e) => onUnsubClick(e, this.props.showMessage)
                              }
                            >
                              <FormattedMessage
                                id="unsub"
                                defaultMessage="UNSUBSCRIBE"
                              />
                            </a>
                          </div>
                        )}
                        {kwDomain && !isMobio360Plus() ? (
                          <div className="navigate-item">
                            <a href="#" onClick={this.onUnsubClickKW}>
                              <FormattedMessage
                                id="unsub"
                                defaultMessage="UNSUBSCRIBE"
                              />
                            </a>
                          </div>
                        ) : null}

                        {bhDomain && !isMobio360Plus() ? (
                          <div className="navigate-item">
                            <a href="#" onClick={this.onUnsubClickBH}>
                              <FormattedMessage
                                id="unsub"
                                defaultMessage="UNSUBSCRIBE"
                              />
                            </a>
                          </div>
                        ) : null}

                        {zaDomain ? (
                          <div className="unsub_text">
                            {unsubscribeTextFun()}
                          </div>
                        ) : null}
                        {bizaoDomain ? (
                          <div className="navigate-item">
                            {ppLinkBizao[config.domain] ? (
                              <a href={ppLinkBizao[config.domain]}>
                                <FormattedMessage
                                  id="privacyPolicy"
                                  defaultMessage="Privacy Policy"
                                />
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : null}
                        {bizaoDomain ? (
                          <div className="navigate-item">
                            <a href={tncLinkBizao[config.domain]}>
                              <FormattedMessage
                                id="tnc"
                                defaultMessage="Terms &amp; Conditions"
                              />
                            </a>
                          </div>
                        ) : null}

                        <div></div>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col sm="4" xs="5">
                <div className="account__image">
                  <div className="account__input">
                    <label
                      className="account__input__label account__input__label--image"
                      htmlFor="photo"
                    >
                      <img
                        className="avatar-image"
                        alt="Edit Photo"
                        src={
                          this.state.photo
                            ? this.state.photo
                            : account.user.profilePic
                              ? account.user.profilePic
                              : "img/avatar-with-camera.png"
                        }
                      />
                      <span className="avatar-text">
                        <FormattedMessage
                          id="editPhoto"
                          defaultMessage="Edit Photo"
                        />
                      </span>
                    </label>
                    <input
                      type="file"
                      className="account__input__field"
                      name="photo"
                      id="photo"
                      accept="image/gif, image/jpeg, image/png"
                      onChange={this.onFileChange}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
          {isWithdrawEnabled(config.domain) ? (
            <div className="navigate-item">
              <a
                href={`https://checksubscription.com/withdraw?c=${domain}&product=${productName}&country=${country}&language=${lang}&portalSource=${productName}&rockmanId=${this.props.access.subscriptionInfo.rockmanId}&msisdn=${this.props.access.subscriptionInfo.msisdn_full || ""}`}
                target="_blank"
                rel="noopener noreferrer"
                className="account__default__label"
                style={{ marginTop: "10%" }}
              >
                <FormattedMessage
                  id="Withdraw_from_contract"
                  defaultMessage="Withdraw from Contract"
                />
              </a>
            </div>
          ) : null}
          {showMundoUnsubscribeConfirm && (
            <Modal
              isOpen={showUnsubscribeConfirm}
              toggle={this.closeUnsubscribeConfirm}
              centered
              className="unsubscribe-confirm-modal"
            >
              <ModalBody className="unsubscribe-confirm-modal__body">
                <p className="unsubscribe-confirm-modal__message">
                  <FormattedMessage
                    id="confirmUnsubscribeMessage"
                    defaultMessage="Are you sure you want to continue?"
                  />
                </p>
              </ModalBody>
              <ModalFooter className="unsubscribe-confirm-modal__actions">
                <Button
                  className="unsubscribe-confirm-modal__cancel"
                  onClick={this.closeUnsubscribeConfirm}
                >
                  <FormattedMessage
                    id="keepSubscription"
                    defaultMessage="Keep my subscription"
                  />
                </Button>
                <Button
                  className="unsubscribe-confirm-modal__confirm"
                  onClick={this.confirmUnsubscribe}
                >
                  <FormattedMessage
                    id="confirmUnsubscribeAction"
                    defaultMessage="Yes, unsubscribe"
                  />
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      showMessage,
      getDetails,
      setDetails,
      setProfilePic,
      setHeaderTitle,
      getInterests,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/components/Account/Account.js